import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import hubbdata from "./hubbdata";
import favourites from "./favourites";
import vips from "./vips";
import user from "./user";
import post from "./post";
import group from "./group";
import chat from "./chat";
import survey from "./survey";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    hubbdata,
    favourites,
    vips,
    user,
    post,
    group,
    chat,
    survey,
  },
  state: {
    loaderStatus: {
      visability: false,
      text: "",
    },
  },
  mutations: {
    setloaderStatus(state, loaderStatusData) {
      state.loaderStatus = loaderStatusData;
    },
  },
  actions: {
    updateLoaderStatus({ commit }, loaderData) {
      commit("setloaderStatus", {
        visability: loaderData.visability,
        text: loaderData.text,
      });
    },
  },
  getters: {
    loaderStatus(state) {
      return state.loaderStatus;
    },
  },
  plugins: [
    new VuexPersistence({
      storage: window.localStorage,
      modules: ["vips", "favourites"],
      key: "baseline-ealing-store",
      strictMode: process.env.NODE_ENV !== "production",
      restoreState: (key, storage) => {
        try {
          const value = storage.getItem(key);
          if (!value) return null;

          const state = JSON.parse(value);

          // Validate favourites state
          if (state.favourites) {
            // Ensure favourites is an array
            if (!Array.isArray(state.favourites.favourites)) {
              console.warn('Corrupted favourites state detected, resetting...');
              state.favourites = { favourites: [] };
            } else {
              // Clean up any invalid entries
              state.favourites.favourites = state.favourites.favourites.filter(item => {
                return item && typeof item === 'object' && item.id;
              });
            }
          }

          return state;
        } catch (e) {
          console.warn('Failed to restore state, clearing storage:', e);
          storage.removeItem(key);
          return null;
        }
      },
      reducer: (state) => ({
        favourites: state.favourites,
        vips: state.vips,
      }),
      filter: (mutation) => [
        "favourites/updateFavourites",
        "vips/updateVips"
      ].includes(mutation.type),
      // Handle storage errors
      assertStorage: () => {
        try {
          const test = "test";
          window.localStorage.setItem(test, test);
          window.localStorage.removeItem(test);
          return true;
        } catch (e) {
          console.warn("Vuex persistence storage test failed, falling back to memory only:", e);
          return false;
        }
      },
    }).plugin
  ],
});

export default store;
